// Libraries
import React from 'react'
import { Popover } from '@material-ui/core'

// Subcomponents
import Dropzone from './Dropzone'

function Dragzone({ anchorEl, setAnchorEl, acceptCallback, rejectCallback }) {
   const open = Boolean(anchorEl)
   const id = open ? 'simple-popover' : undefined

   function closePopover() {
      setAnchorEl(null)
   }

   return (
      <Popover
         id={id}
         open={open}
         anchorOrigin={{
            vertical: 'top',
            horizontal: 'left'
         }}
         transformOrigin={{
            vertical: 'bottom',
            horizontal: 'right'
         }}
         anchorEl={anchorEl}
         onClose={closePopover}
      >
         <Dropzone
            closePopover={closePopover}
            acceptCallback={acceptCallback}
            rejectCallback={rejectCallback}
         />
      </Popover>
   )
}

export default Dragzone
